export default __webpack_public_path__ + "static/redStone-f224b34bd0fab44eb7304721de712edd.svg";